import { post } from "@/request/http";

// 获取实验列表
// 文档地址：http://showdoc.mools.net/web/#/13?page_id=111
export const getExpList = p => post("/exp/getExpList", p);
